import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
// EmailJS removed for simplicity; using FormSubmit direct POST
import { NavLink } from 'react-router-dom';
import { trackForm } from '../../utils/analytics';

const ContactUs = () => {
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  // Simplified: no async submission state needed with FormSubmit

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      trackForm('contact_us', 'attempt');
      const response = await fetch('https://formsubmit.co/ajax/support@jnanakshi.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          _captcha: false,
          _subject: 'New Contact Form Submission - Jnanakshi Solutions'
        })
      });
      if (!response.ok) throw new Error('Failed to submit');
      // optional: await response.json();
      alert("Thank you for contacting us. Someone will respond soon.");
      trackForm('contact_us', 'success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      navigate('/');
    } catch (err) {
      alert('Sorry, there was an error sending your message. Please try again.');
      // eslint-disable-next-line no-console
      console.error(err);
      trackForm('contact_us', 'error');
    }
  };

  return (
    <div className={`min-h-screen pt-16 sm:pt-20 ${isDark ? 'bg-dark-900' : 'bg-gray-50'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className={`text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 ${
            isDark ? 'text-white' : 'text-gray-900'
          }`}>
            Contact Us
          </h1>
          <p className={`text-lg sm:text-xl max-w-2xl mx-auto ${
            isDark ? 'text-gray-300' : 'text-gray-600'
          }`}>
            Get in touch with us. We'd love to hear from you and help with your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Contact Information */}
          <div className="space-y-6">
            <div>
              <h2 className={`text-2xl font-semibold mb-6 ${
                isDark ? 'text-white' : 'text-gray-900'
              }`}>
                Get in Touch
              </h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0">
                    <svg className="w-6 h-6 text-jnanakshi-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h3 className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                      Email
                    </h3>
                    <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                      support@jnanakshi.com
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0">
                    <svg className="w-6 h-6 text-jnanakshi-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h3 className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                      Phone
                    </h3>
                    <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                      +91 7760556768
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0">
                    <svg className="w-6 h-6 text-jnanakshi-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h3 className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                      Location
                    </h3>
                    <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                      Bangalore, India
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0">
                    <svg className="w-6 h-6 text-jnanakshi-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h3 className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                      Response Time
                    </h3>
                    <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                      We typically respond within 24 hours
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className={`p-6 sm:p-8 rounded-lg shadow-lg ${
            isDark ? 'bg-dark-800' : 'bg-white'
          }`}>
            <h2 className={`text-2xl font-semibold mb-6 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}>
              Send us a Message
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6 text-left">
              <div className="text-left">
                <label htmlFor="name" className={`block text-sm font-medium mb-2 ${
                  isDark ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-jnanakshi-500 focus:border-transparent transition-colors ${
                    isDark 
                      ? 'bg-dark-700 border-dark-600 text-white placeholder-gray-400' 
                      : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                  }`}
                  placeholder="Enter your full name"
                />
              </div>

              <div className="text-left">
                <label htmlFor="email" className={`block text-sm font-medium mb-2 ${
                  isDark ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-jnanakshi-500 focus:border-transparent transition-colors ${
                    isDark 
                      ? 'bg-dark-700 border-dark-600 text-white placeholder-gray-400' 
                      : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                  }`}
                  placeholder="Enter your email address"
                />
              </div>

              <div className="text-left">
                <label htmlFor="subject" className={`block text-sm font-medium mb-2 ${
                  isDark ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Subject *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-jnanakshi-500 focus:border-transparent transition-colors ${
                    isDark 
                      ? 'bg-dark-700 border-dark-600 text-white placeholder-gray-400' 
                      : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                  }`}
                  placeholder="What's this about?"
                />
              </div>

              <div className="text-left">
                <label htmlFor="message" className={`block text-sm font-medium mb-2 ${
                  isDark ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-jnanakshi-500 focus:border-transparent transition-colors resize-none ${
                    isDark 
                      ? 'bg-dark-700 border-dark-600 text-white placeholder-gray-400' 
                      : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                  }`}
                  placeholder="Tell us how we can help you..."
                />
              </div>

              <button
                type="submit"
                className={`w-full py-3 px-6 rounded-lg font-medium transition-colors duration-200 bg-jnanakshi-500 hover:bg-jnanakshi-600 focus:ring-2 focus:ring-jnanakshi-500 focus:ring-offset-2 text-white shadow-lg`}
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Footer Component */}
      <footer className="bg-gray-800 dark:bg-dark-800 text-white py-8 sm:py-10 lg:py-12 transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {/* About Section */}
            <div className="sm:col-span-2 lg:col-span-1">
              <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">About Jnanakshi Solutions</h3>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base leading-relaxed">
                At Jnanakshi Solutions, we are committed to bridging the critical gap between academic knowledge 
                and professional competence. We specialize in providing immersive live workshops and targeted 
                training programs designed to empower college students and transform them into industry-ready professionals.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <NavLink
                    to="/about-us"
                    className="text-gray-400 dark:text-gray-300 hover:text-white transition text-sm sm:text-base"
                  >
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services"
                    className="text-gray-400 dark:text-gray-300 hover:text-white transition text-sm sm:text-base"
                  >
                    Services
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Contact Us</h3>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base">
                <strong>Address:</strong> Bangalore, India
              </p>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base mt-2">
                <strong>Phone:</strong> +91 7760556768
              </p>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base mt-2">
                <strong>Email:</strong> support@jnanakshi.com
              </p>
            </div>
          </div>

          <div className="mt-8 sm:mt-10 border-t border-gray-700 dark:border-dark-600 pt-4 sm:pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
            {/* Social Media Links */}
            <div className="flex space-x-4 sm:space-x-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>

            {/* Copyright */}
            <p className="text-gray-400 dark:text-gray-300 text-xs sm:text-sm text-center sm:text-right">
              &copy; {new Date().getFullYear()} Jnanakshi Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Chatbot Component */}
      {/* Keep Chatbot as is if you want it below the footer, or move above */}
      
    </div>
  );
};

export default ContactUs;
